var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViewFirm',{attrs:{"id":_vm.id,"notPopup":false,"tablesProp":_vm.tablesProp,"noNote":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }